<template>
  <FormSection title="Kagami">
    <div class="kagami-section">
      <div class="kagami-field">
        <label>Parent Liaison</label>
        <select class="form-control" v-model="form.APF_ParentLiaison" :disabled="!canEdit">
          <option value="">Please select...</option>
          <option v-for="(opt, id) in parentLiaisonList" :value="opt.CONid" :key="`PL_${id}`">
            {{ opt.CONname }}
          </option>
        </select>
      </div>

      <div class="kagami-field">
        <label>Family No</label>
        <input type="text" class="form-control" v-model="form.APF_FamilyNumber" :disabled="!canEdit" />
      </div>

      <div class="kagami-field">
        <label>Student No</label>
        <input type="text" class="form-control" :value="studentIndexNumber" disabled />
      </div>

      <div class="kagami-field">
        <label>Academic Year</label>
        <input type="text" class="form-control" :value="academicYear.academicYear" disabled />
      </div>

      <div class="kagami-field">
        <label>Academic Level</label>
        <input type="text" class="form-control" :value="academicYear.level" disabled />
      </div>
    </div>
  </FormSection>
</template>

<script>
import FormSection from './FormSection.vue'

export default {
  name: 'KagamiSection',
  components: {
    FormSection,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    parentLiaisonList: {
      type: Array,
      default: () => [],
    },
    studentIndexNumber: {
      type: String,
      default: '',
    },
    academicYear: {
      type: Object,
      default: () => ({}),
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.kagami-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.kagami-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kagami-field label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:disabled {
  background-color: #f8f9fa;
  opacity: 0.7;
}

.form-control:focus {
  outline: none;
  border-color: #426dff;
  box-shadow: 0 0 0 2px rgba(66, 109, 255, 0.2);
}

@media (max-width: 768px) {
  .kagami-section {
    grid-template-columns: 1fr;
  }
}
</style>
